import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { sbaAxios } from '../../utils/sbaAxios';
import { AgGridReact } from "ag-grid-react";
import noDataAvailable from '../../../Images/noDataAvailable.svg';
import { getAssetTransactionWidget } from '../../../config/apiConfig';
import moment from "moment";

export const AssetTransactionsList = () => {
    const params = useParams();
    const [torender, SetToRender] = useState(false);
    const [assetTransactions, setAssetTransactions] = useState([]);

    const colDefs = [
        {headerName: "Portfolio Name", field: "PortfolioName",tooltipField:"PortfolioName",  flex:1},
        { 
            headerName: "Date", 
            field: "TransDate",
            valueFormatter: (params) => {
              if (!params.value) return "";
              return moment(params.value).format("MM/DD/YYYY");
            }, 
            flex:0.5
          },
        { 
            headerName: "Market Value", 
            field: "MarketValue",
            valueFormatter: (params) => {
                return new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }).format(params.value);
            }, 
            flex: 0.5
          },
    ]
    const defaulColumns = { filter: false };
    const assetID = params.Asset;

    const fetchAssetTransactions = async() => {
        try{
            const list = await sbaAxios({
                url: getAssetTransactionWidget,
                params:{
                    assetId: assetID
                }
            });
            setAssetTransactions(list);
        }
        catch(e){
            setAssetTransactions([]);
        }
    }
   
    useEffect(() => {
        fetchAssetTransactions(); 
    }, []);

    return (
        <>
        {assetTransactions?.length === 0 ? 
            <div className='d-flex w-100 my-4 h-100'>
                <img src={noDataAvailable} alt='NO DATA AVAILABLE' className='m-auto' width={'30%'} />
            </div>:
            <div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                <AgGridReact 
                    rowData={assetTransactions}
                    columnDefs={colDefs}
                    defaultColDef={defaulColumns}
                >
                </AgGridReact>
            </div>
        }
        </>
    )
}
